export const safeParse = <T>(value: string, fallback: T): T => {
	try {
		return <T>JSON.parse(value);
	} catch {
		return fallback;
	}
};
